import { useState, useContext, useMemo } from 'react';
import type { UserUpdateDTO } from '@klangio/ai2notes-ts-client';
import { UsersService } from '@klangio/ai2notes-ts-client';
import { UserContext } from '../context';

const useUserDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const { refresh } = useContext(UserContext);

  const onSaveChanges = (data: UserUpdateDTO) => {
    setIsSaving(true);
    UsersService.usersUpdateUser(data).finally(() => {
      setIsSaving(true);
      refresh();
    });
  };
  const returnValue = useMemo(
    () => ({
      isDialogOpen: isOpen,
      isSaving,
      setOpenDialog: setIsOpen,
      onSaveChanges,
    }),
    [isOpen, isSaving],
  );

  return returnValue;
};

export default useUserDialog;
